import React from 'react';
import styles from '../styles/Contact.module.css';
import Corfu from "../images/corfu.jpg";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const Contact = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  const API = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      message: e.target.message.value,
      company: e.target.company?.value || ""
    };

    try {
      await axios.post(`${API}/api/contact`, formData);

      alert(t("contact.alerts.success"));
      e.target.reset();

    } catch (error) {
      console.error(error);
      alert(t("contact.alerts.error"));
    }
  };

  return (
    <>
      <section className={styles.contactSection}>
        <div className={styles.container}>
          <h1 className={styles.title}>{t("contact.title")}</h1>
          
          <p className={styles.subtitle}>
            {t("contact.subtitle")}
          </p>

          <div className={styles.contactGrid}>
            {/* Left */}
            <div className={styles.leftColumn}>
              <div className={styles.mapContainer}>
                <div className={styles.mapPlaceholder}>
                  <img 
                    src={Corfu} 
                    alt="Map of Corfu"
                    className={styles.mapImage}
                  />
                </div>
              </div>

              <div className={styles.locationInfo}>
                <p className={styles.location}>{t("contact.location_value")}</p>
                <p className={styles.phone}>☎ +30 695 530 2366</p>
                <p className={styles.email}>✉ transferstoby@gmail.com</p>
              </div>
            </div>

            {/* Right */}
            <div className={styles.rightColumn}>
              <form className={styles.contactForm} onSubmit={handleSubmit}>
                <input type="text" name="company" style={{ display: "none" }} />

                <div className={styles.formGroup}>
                  <label htmlFor="name">{t("contact.form.name")}</label>
                  <input type="text" id="name" name="name" required />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="email">{t("contact.form.email")}</label>
                  <input type="email" id="email" name="email" required />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="phone">{t("contact.form.phone")}</label>
                  <input type="tel" id="phone" name="phone" required />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="message">{t("contact.form.message")}</label>
                  <textarea id="message" name="message" rows="5" required />
                </div>

                <div className={styles.checkboxGroup}>
                  <input type="checkbox" id="terms" name="terms" required />
                  <label htmlFor="terms">
                    {t("contact.terms.text")}{" "}
                    <a href={`/${lang}/terms`} target="_blank" rel='noreferrer'>
                      {t("contact.terms.terms")}
                    </a>{" "}
                    {t("and")}{" "}
                    <a href={`/${lang}/privacy`} target="_blank" rel='noreferrer'>
                      {t("contact.terms.privacy")}
                    </a>
                  </label>
                </div>

                <button type="submit" className={styles.submitButton}>
                  {t("contact.form.submit")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;